module.exports = __webpack_public_path__ + "static/lo-80c93c3fa9e8b272c87cb6eee4df3dda.png";